/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProjectChangeLogQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  filters?: Types.InputMaybe<Types.ChangeLogFilters>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ProjectChangeLogQuery = { projectChangeLog: { __typename: 'ChangeLogConnection', edges: Array<{ __typename: 'ChangeLogEntryEdge', cursor: string, node: { __typename: 'ChangeLogEntry', id: string, occurredAt: any, operation?: Types.ChangeLogOperation | null, entityType: string, field?: string | null, correlationId: string, actor: { __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }, entity: { __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }, oldValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null, newValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null } }>, pageInfo: { __typename: 'PageInfo', hasNextPage?: boolean | null, endCursor?: string | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions', missingPermissions: Array<Types.PermissionName> } };

export type ProjectChangeLog_EntryFragment = { __typename: 'ChangeLogEntry', id: string, occurredAt: any, operation?: Types.ChangeLogOperation | null, entityType: string, field?: string | null, correlationId: string, actor: { __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }, entity: { __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }, oldValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null, newValue?: { __typename: 'ChangeLogFieldValue', recorded: boolean, value?: any | null, label?: string | null } | null };

export type ProjectChangeLogFacetsQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
}>;


export type ProjectChangeLogFacetsQuery = { projectChangeLogFacets: { __typename: 'ChangeLogFacets', operations: Array<Types.ChangeLogOperation>, hasPureEvents: boolean, actors: Array<{ __typename: 'ChangeLogActor', actorId: string, userId?: string | null, label?: string | null }>, entities: Array<{ __typename: 'ChangeLogEntity', entityId: string, entityType: string, name?: string | null, position?: string | null, isDeleted: boolean, nameSpan?: { __typename: 'ChangeLogEntityNameSpan', from?: any | null, till?: any | null, date?: any | null, durationMinutes?: number | null } | null }> } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions', missingPermissions: Array<Types.PermissionName> } };

export const ProjectChangeLog_EntryFragmentDoc = gql`
    fragment ProjectChangeLog_Entry on ChangeLogEntry {
  id
  occurredAt
  operation
  entityType
  field
  correlationId
  actor {
    actorId
    userId
    label
  }
  entity {
    entityId
    entityType
    name
    position
    isDeleted
    nameSpan {
      from
      till
      date
      durationMinutes
    }
  }
  oldValue {
    recorded
    value
    label
  }
  newValue {
    recorded
    value
    label
  }
}
    `;
export const ProjectChangeLogDocument = gql`
    query ProjectChangeLog($projectId: ID!, $filters: ChangeLogFilters, $first: Int, $after: String) {
  projectChangeLog(
    projectId: $projectId
    filters: $filters
    first: $first
    after: $after
  ) {
    ... on ChangeLogConnection {
      edges {
        cursor
        node {
          ...ProjectChangeLog_Entry
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    ... on MissingPermissions {
      missingPermissions
    }
  }
}
    ${ProjectChangeLog_EntryFragmentDoc}`;

/**
 * __useProjectChangeLogQuery__
 *
 * To run a query within a React component, call `useProjectChangeLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChangeLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChangeLogQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useProjectChangeLogQuery(baseOptions: Apollo.QueryHookOptions<ProjectChangeLogQuery, ProjectChangeLogQueryVariables> & ({ variables: ProjectChangeLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>(ProjectChangeLogDocument, options);
      }
export function useProjectChangeLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>(ProjectChangeLogDocument, options);
        }
export function useProjectChangeLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>(ProjectChangeLogDocument, options);
        }
export type ProjectChangeLogQueryHookResult = ReturnType<typeof useProjectChangeLogQuery>;
export type ProjectChangeLogLazyQueryHookResult = ReturnType<typeof useProjectChangeLogLazyQuery>;
export type ProjectChangeLogSuspenseQueryHookResult = ReturnType<typeof useProjectChangeLogSuspenseQuery>;
export type ProjectChangeLogQueryResult = Apollo.QueryResult<ProjectChangeLogQuery, ProjectChangeLogQueryVariables>;
export const ProjectChangeLogFacetsDocument = gql`
    query ProjectChangeLogFacets($projectId: ID!) {
  projectChangeLogFacets(projectId: $projectId) {
    ... on ChangeLogFacets {
      actors {
        actorId
        userId
        label
      }
      entities {
        entityId
        entityType
        name
        position
        isDeleted
        nameSpan {
          from
          till
          date
          durationMinutes
        }
      }
      operations
      hasPureEvents
    }
    ... on MissingPermissions {
      missingPermissions
    }
  }
}
    `;

/**
 * __useProjectChangeLogFacetsQuery__
 *
 * To run a query within a React component, call `useProjectChangeLogFacetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectChangeLogFacetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectChangeLogFacetsQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *   },
 * });
 */
export function useProjectChangeLogFacetsQuery(baseOptions: Apollo.QueryHookOptions<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables> & ({ variables: ProjectChangeLogFacetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>(ProjectChangeLogFacetsDocument, options);
      }
export function useProjectChangeLogFacetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>(ProjectChangeLogFacetsDocument, options);
        }
export function useProjectChangeLogFacetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>(ProjectChangeLogFacetsDocument, options);
        }
export type ProjectChangeLogFacetsQueryHookResult = ReturnType<typeof useProjectChangeLogFacetsQuery>;
export type ProjectChangeLogFacetsLazyQueryHookResult = ReturnType<typeof useProjectChangeLogFacetsLazyQuery>;
export type ProjectChangeLogFacetsSuspenseQueryHookResult = ReturnType<typeof useProjectChangeLogFacetsSuspenseQuery>;
export type ProjectChangeLogFacetsQueryResult = Apollo.QueryResult<ProjectChangeLogFacetsQuery, ProjectChangeLogFacetsQueryVariables>;